module.exports = __webpack_public_path__ + "8854f3a2355d67f6b0757f555fc8579b.svg";